/*
 * @Author: jiurigege
 * @Date: 2019-08-01 15:15:53
 * @Last Modified: jiurigege
 * @Last Modified time: 2019-09-11 15:07:58
 * @Description: message
 */

import { checkMobile } from '../assets/js/utils';

// useragent
// eslint-disable-next-line
let UA = '';
if (process.client) {
  UA = navigator.userAgent;
}

// osType: android/ios/pc
// eslint-disable-next-line
let OsType = '';
if (checkMobile().isAndroid()) {
  OsType = 'android';
} else if (checkMobile().isIos()) {
  OsType = 'ios';
} else if (checkMobile().isPC()) {
  OsType = 'pc';
}

// check if browser is support mediasource extension
const IsSupportHls = process.client
  ? 'MediaSource' in window &&
    MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.2"')
  : false;

export { UA, OsType, IsSupportHls };
